















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Secret extends Vue {
    @Prop({ default: 'foo' }) value!: string;
    show: boolean = false;

    get obscur() {
        return '*'.repeat(this.value.length);
    }
}
